/**
 * 微信网页授权工具类
 */
import axios from 'axios'

// 后端API地址
const API_BASE_URL = process.env.VUE_APP_API_BASE_URL || 'http://127.0.0.1:8080'

/**
 * 检查是否在微信环境中
 */
export const isWechatBrowser = () => {
  return /micromessenger/i.test(navigator.userAgent)
}

/**
 * 获取URL参数
 */
const getUrlParam = (name) => {
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  const r = window.location.search.substr(1).match(reg)
  if (r != null) return decodeURIComponent(r[2])
  return null
}

/**
 * 获取微信授权链接
 * @param {string} redirectUri 授权后重定向的回调地址
 * @param {string} state 可选，状态参数
 * @returns {Promise<string>} 授权链接
 */
export const getWechatAuthUrl = async (redirectUri, state = '') => {
  try {
    console.log('[wechatAuth] request authorize', {
      api: `${API_BASE_URL}/wechat/oauth/authorize`,
      redirectUri: redirectUri || window.location.href,
      state
    })
    const response = await axios.get(`${API_BASE_URL}/wechat/oauth/authorize`, {
      params: {
        redirectUri: redirectUri || window.location.href,
        state: state
      },
      timeout: 10000 // 10秒超时
    })

    console.log('[wechatAuth] authorize response', response && response.data)
    if (response.data.code === 200 && response.data.data && response.data.data.authUrl) {
      const url = response.data.data.authUrl
      console.log('[wechatAuth] authorize authUrl', url)
      return url
    } else {
      const errorMsg = response.data.msg || response.data.data?.msg || '获取授权链接失败'
      throw new Error(errorMsg)
    }
  } catch (error) {
    console.error('获取微信授权链接失败:', error)
    // 如果是网络错误，返回更友好的错误信息
    if (error.response) {
      const errorMsg = error.response.data?.msg || error.response.data?.message || '获取授权链接失败'
      throw new Error(errorMsg)
    } else if (error.request) {
      throw new Error('网络请求失败，请检查网络连接')
    } else {
      throw error
    }
  }
}

/**
 * 处理微信授权回调
 * 从URL中获取code，调用后端接口获取OpenId
 * @returns {Promise<Object>} {openId, userId}
 */
export const handleWechatCallback = async () => {
  const code = getUrlParam('code')
  const state = getUrlParam('state')

  if (!code) {
    return null
  }

  try {
    const response = await axios.get(`${API_BASE_URL}/wechat/oauth/callback`, {
      params: {
        code: code,
        state: state
      },
      timeout: 10000 // 10秒超时
    })

    if (response.data.code === 200) {
      const { openId, userId } = response.data.data

      // 保存OpenId到本地存储
      if (openId) {
        localStorage.setItem('wechat_openId', openId)
        if (userId) {
          localStorage.setItem('wechat_userId', userId)
        }
      }

      // 清除URL中的code参数，避免重复处理
      const url = new URL(window.location.href)
      url.searchParams.delete('code')
      url.searchParams.delete('state')
      window.history.replaceState({}, '', url.toString())

      return { openId, userId }
    } else {
      throw new Error(response.data.msg || '授权失败')
    }
  } catch (error) {
    console.error('处理微信授权回调失败:', error)
    throw error
  }
}

/**
 * 获取本地存储的OpenId
 * @returns {string|null} OpenId
 */
export const getStoredOpenId = () => {
  return localStorage.getItem('wechat_openId')
}

/**
 * 清除本地存储的OpenId
 */
export const clearStoredOpenId = () => {
  localStorage.removeItem('wechat_openId')
  localStorage.removeItem('wechat_userId')
}

/**
 * 初始化微信授权（已废弃，改为手动授权）
 * 保留此函数以兼容旧代码
 */
export const initWechatAuth = async () => {
  console.log('[wechatAuth] initWechatAuth 已废弃，请使用手动授权按钮')
  return getStoredOpenId()
}

